import { render, staticRenderFns } from "./public-quizzes-list.html?vue&type=template&id=1f3b87cf&scoped=true&"
import script from "./public-quizzes-list.js?vue&type=script&lang=js&"
export * from "./public-quizzes-list.js?vue&type=script&lang=js&"
import style0 from "./public-quizzes-list.scss?vue&type=style&index=0&id=1f3b87cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b87cf",
  null
  
)

export default component.exports